var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"slide","mode":"out-in"}},[(_vm.isActive)?_c('div',{key:"tab.name",staticClass:"tab"},[_vm._t("default")],2):_vm._e()])}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6c8bc1d0","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/person/residents/new-resident-details/ResidentTab.vue
// module id = eIlr
// module chunks = 0 1